// extracted by mini-css-extract-plugin
export default {"cardTitle":"score-overview-card_cardTitle__LX-gC","cardContent":"score-overview-card_cardContent__iT77g"};